export default "__VITE_ASSET__qjuKvlxg__"